module.exports = __webpack_public_path__ + "assets/img/discernment_license_scene3.f6069978.png";